import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import CriarAgendamento from "../../../../Components/CardsPages/Atendimento/CriarAgendamento";
import AgendamentoPeloCliente from "../../../../Components/CardsPages/Atendimento/CriarAgendamento/AgendamentoPeloCliente";
import ModalComponent from "../../../../Components/Modais";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import Table from "../../../../Components/Table";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ETAPA_ASSISTENCIA_TECNICA } from "../../../../Constants/AssistenciaTecnica/EtapaTipoCaso";
import { ETAPA_ENTREGA_CHAVES } from "../../../../Constants/EntregaChaves";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { useUserInfor } from "../../../../Context/User";
import {
    DeletarAgendamentoDeAtendimentoController,
    ListarAgendamentosDeAtendimentoController,
} from "../../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import { GetHistoricoCasoVistoriaController } from "../../../../Controllers/VistoriaEntregaChaves/AcoesVistoria/AcoesVistoriaController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IAgendamento } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import { AlertConfirm } from "../../../../Tools/SweetAlerts";

interface IAgendamentosDoAtendimentoProps {
    Atendimento: IAtendimentoExtraDetalhado;
    idCaso: number;
    updatelstAgendamentos?: Function;
}

export default function AgendamentosDoAtendimento(
    props: IAgendamentosDoAtendimentoProps
) {
    const { FUNCOES } = useUserInfor().UserInfor;
    const { id } = useModuloInfo();

    const { ReloadHistorico } = useHistoricoContext();

    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const AtendimentoDetalhado = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;

    const {
        value: lstAgendamentos,
        loading,
        execute,
    } = useAsyncEffect(
        () => ListarAgendamentosDeAtendimentoController(props.idCaso),
        [props.idCaso]
    );

    useEffect(() => {
        if (props.updatelstAgendamentos && lstAgendamentos)
            props.updatelstAgendamentos!(lstAgendamentos);
    }, [props, lstAgendamentos]);

    const { value: historicoCasoVistoria } = useAsyncEffect(async () => {
        if (
            AtendimentoDetalhado.ID_TIPO_CASO ===
            ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO
        )
            return GetHistoricoCasoVistoriaController(props.idCaso);
    });

    function mostrarJustificativaNovoAgendamento() {
        return [
            ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_CLIENTE_NAO_COMPARECEU
                .CD_ETAPA,
            ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_NAO_REALIZADA.CD_ETAPA,
        ].some((etapa) => etapa === AtendimentoDetalhado?.CD_ETAPA);
    }

    function excluirAgendamentoAssistenciaTecnica(row: IAgendamento) {
        if (id === ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO) {
            return [
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_REVISTORIA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA_AGENDAMENTO_PENDENTE
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA_CLIENTE_NAO_COMPARECEU
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA_NAO_REALIZADA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_AGENDAMENTO_PENDENTE
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_CLIENTE_NAO_COMPARECEU
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_PREVIA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_UNIDADE_ESTOQUE.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_NAO_REALIZADA.CD_ETAPA,
            ].some((etapa) => etapa === props.Atendimento?.CD_ETAPA);
        } else if (id === ACESSOS.ASSISTENCIA.ID_MODULO) {
            return (
                ((props.Atendimento?.NR_ETAPA ===
                    ETAPA_ASSISTENCIA_TECNICA.AGENDAR_MANUTENCAO.NR_ETAPA ||
                    props.Atendimento?.NR_ETAPA ===
                        ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_DE_MANUTENCAO
                            .NR_ETAPA) &&
                    row.ID_TIPO_COMPROMISSO === 2) ||
                ((props.Atendimento?.NR_ETAPA ===
                    ETAPA_ASSISTENCIA_TECNICA.AGENDAMENTO_VISTORIA_INICIAL
                        .NR_ETAPA ||
                    props.Atendimento?.NR_ETAPA ===
                        ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL
                            .NR_ETAPA) &&
                    row.ID_TIPO_COMPROMISSO === 1)
            );
        }
    }

    function criarAgendamento() {
        if (id === ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO) {
            return [
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_REVISTORIA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA_AGENDAMENTO_PENDENTE
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA_CLIENTE_NAO_COMPARECEU
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_ENTREGA_NAO_REALIZADA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_AGENDAMENTO_PENDENTE
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_CLIENTE_NAO_COMPARECEU
                    .CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_PREVIA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_UNIDADE_ESTOQUE.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_NAO_REALIZADA.CD_ETAPA,
                ETAPA_ENTREGA_CHAVES.AGENDAR_VISTORIA_PREVIA_UNIDADE.CD_ETAPA,
            ].some((etapa) => etapa === props.Atendimento?.CD_ETAPA);
        } else if (id === ACESSOS.ASSISTENCIA.ID_MODULO) {
            return [
                ETAPA_ASSISTENCIA_TECNICA.AGENDAMENTO_VISTORIA_INICIAL.NR_ETAPA,
                ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_VISTORIA_INICIAL.NR_ETAPA,
                ETAPA_ASSISTENCIA_TECNICA.AGENDAR_MANUTENCAO.NR_ETAPA,
                ETAPA_ASSISTENCIA_TECNICA.EXECUCAO_DE_MANUTENCAO.NR_ETAPA,
            ].some((etapa) => etapa === props.Atendimento?.NR_ETAPA);
        }
    }

    const agendamentoColumns: Array<ColumnDescription<IAgendamento>> = [
        {
            dataField: "DS_ASSUNTO",
            text: "Assunto",
        },
        {
            dataField: "DT_INICIO",
            text: "Data/Hora Inicial",
            formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
        },
        {
            dataField: "DT_FIM",
            text: "Data/Hora Final",
            formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
        },
        {
            dataField: "DS_USUARIO",
            text: "Responsável",
        },
        {
            dataField: "DS_TIPO_COMPROMISSO",
            text: "Tipo",
        },
        {
            dataField: "VIST_EXCLUIR_AGENDAMENTO",
            text: "Excluir Agendamento",
            formatter: (_, row) => (
                <>
                    {(excluirAgendamentoAssistenciaTecnica(row) ||
                        FUNCOES.some(
                            (f) => f.NM_FUNCAO === "VIST_EXCLUIR_AGENDAMENTO"
                        )) && (
                        <span
                            className="mr-2 text-danger text-hover-info"
                            role="button"
                            onClick={() => {
                                AlertConfirm(
                                    "Deseja apagar este agendamento?"
                                ).then((result) => {
                                    if (result.isConfirmed) {
                                        DeletarAgendamentoDeAtendimentoController(
                                            row.ID_COMPROMISSO
                                        ).then(() => {
                                            execute();
                                            if (
                                                props.updatelstAgendamentos &&
                                                lstAgendamentos
                                            )
                                                props.updatelstAgendamentos!(
                                                    lstAgendamentos
                                                );
                                            ReloadHistorico();
                                        });
                                    }
                                });
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </span>
                    )}
                </>
            ),
        },
    ];

    return (
        <>
            <div className="card card-custom py-2">
                {mostrarJustificativaNovoAgendamento() && (
                    <div className="m-3 d-flex align-items-center">
                        <h4 className="m-0">
                            Indicação de Agenda informada pela Obra:
                        </h4>{" "}
                        <span
                            className="text-danger ml-4 mb-0"
                            style={{ fontSize: 15 }}
                        >
                            {historicoCasoVistoria?.DS_HISTORICO}
                        </span>
                    </div>
                )}
                <div className="d-flex justify-content-end">
                    {criarAgendamento() && (
                        <>
                            <button
                                className="btn btn-primary d-flex align-items-center justify-content-center flex-nowrap ml-3 mr-3 g-2 m-3"
                                disabled={
                                    AtendimentoDetalhado.FL_CASO_PARALIZADO
                                }
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent:
                                            "Agendamento pelo cliente por email",
                                        IconHeader: faPlus,
                                        Component: () => (
                                            <AgendamentoPeloCliente
                                                setShow={setShow}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                }}
                            >
                                Agendamento pelo cliente
                                <span>
                                    <FontAwesomeIcon icon={faPlus} />
                                </span>
                            </button>
                            <button
                                className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap ml-3 mr-3 g-2 m-3"
                                disabled={
                                    AtendimentoDetalhado.FL_CASO_PARALIZADO
                                }
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        headerComponent: "Criar Agendamento",
                                        IconHeader: faPlus,
                                        Component: () => (
                                            <CriarAgendamento
                                                updateList={execute}
                                                setShow={setShow}
                                                Atendimento={props.Atendimento}
                                            />
                                        ),
                                        size: "lg",
                                    });
                                    if (
                                        props.updatelstAgendamentos &&
                                        lstAgendamentos
                                    )
                                        props.updatelstAgendamentos!(
                                            lstAgendamentos
                                        );
                                }}
                            >
                                Novo Agendamento
                                <span>
                                    <FontAwesomeIcon icon={faPlus} />
                                </span>
                            </button>
                        </>
                    )}
                </div>
                <OrSpinner
                    loading={loading && !lstAgendamentos}
                    spinner="capys"
                >
                    {lstAgendamentos ? (
                        <Table
                            data={lstAgendamentos}
                            columns={agendamentoColumns}
                            keyField="ID_COMPROMISSO"
                            noSearch
                            defaultStyle={{
                                align: "center",
                                classes: "p-2",
                            }}
                            bordered={false}
                            striped
                            classes="v-middle-cells"
                            noDataIndication={
                                <div className="text-muted text-center">
                                    Esse atendimento não possui nenhum
                                    agendamento vinculado
                                </div>
                            }
                            loading={loading}
                        />
                    ) : (
                        <div className="text-muted text-center">
                            Não foi possível carregar os agendamentos
                        </div>
                    )}
                </OrSpinner>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
